export default "__VITE_ASSET__7MIl1eWc__"